import Loadable from 'components/Loadable';
import ClientLayout from 'layout/ClientLayout';
import { lazy } from 'react';
import AuthGuard from 'utils/route-guard/AuthGuard';

const ClientView = Loadable(lazy(() => import('pages/client-portal')));


// ==============================|| TALENT ||============================== //

const ClientRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <ClientLayout />
    </AuthGuard>
  ),
  children: [{ path: '/', element: <ClientView /> }]
};

export default ClientRoutes;
